export default "/images/d12039ee39aeb914e155bc47bed27382.avif";